<template>
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-xxl-3 p-lg-0 filter-col">
      <generic-filter :items="publicationsLoaded" :filters="sortedFilters" @filteredItems="getObjects($event)" />
    </div>
    <div class="col-lg-7 col-xl-8 col-xxl-9">
      <div v-if="filteredObjects.length == 0">
        <div class="row publication-filter-list px-3 ps-xl-10 g-0">
          <div class="col-12 mb-5 px-0 pb-5">
            <p>There are no results for the current filters.</p>
          </div>
        </div>
      </div>
      <div class="row publication-row publication-filter-list px-lg-3 ps-xl-6 ps-xxl-10 g-0 pt-lg-2" v-else>
        <div class="col-12 mb-5 px-0 pb-5 border-bottom border-light border-1 pt-lg-3 d-block" v-for="(publication, index) in filteredObjects">
          <publication-card
            v-if="publication.PublicationType === 'Research Publication'"
            :publication="publication"
          />
          <article-card v-else-if="publication.PublicationType === 'Article'" :publication="publication" />
          <press-release-card v-else :publication="publication" />
        </div>
        <div class="col-12 pt-4 pt-lg-6" v-if="filteredObjects.length >= toShow">
          <button @click="showMore($event)" class="btn btn-outline-primary show-more" aria-label="load More Items">Load More</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import { reactive, onUpdated, ref } from 'vue';
  import moment from 'moment';
  import PublicationCard from './PublicationCard';
  import PressReleaseCard from './PressReleaseCard';
  import ArticleCard from './ArticleCard';
  import GenericFilter from './GenericFilter.vue';

  export default {
    name: 'PublicationList',
    props: {
      publications: {
        type: Array,
        required: true
      },
      filters: {
        type: Array,
        default: []
      }
    },
    components: {
      PublicationCard,
      PressReleaseCard,
      ArticleCard,
      GenericFilter
    },
    computed: {
      publicationsLoaded() {
        return this.publications.slice().sort(function (a, b) {
          return moment(b.OriginalPublicationDate, 'MM-DD-YYYY') - moment(a.OriginalPublicationDate, 'MM-DD-YYYY');
        });
      },
    },
    setup(props) {
      let filteredObjects = reactive([]);
      let sortedFilters = ref([]);
      const toShow = 7;
      const title = document.querySelector('.publication-title');

      const order = ['Topics', 'Year', 'Organization', 'Author', 'Format'];
      const filtersArr = [...props.filters];
      filtersArr.sort((a, b) => {
        return order.indexOf(a.Key) - order.indexOf(b.Key);
      });
      sortedFilters.value = filtersArr.filter((filter) => filter.Key !== 'Filters');

      const getObjects = (objects) => {
        const sortedObjects = objects.sort(function (a, b) {
          return moment(b.OriginalPublicationDate, 'MM-DD-YYYY') - moment(a.OriginalPublicationDate, 'MM-DD-YYYY');
        });
        filteredObjects.length = 0;
        [].push.apply(filteredObjects, sortedObjects);
      };

      const showMore = (button) => {
        const hiddenItems = document.querySelectorAll('.border-light.border-1.d-none');

        Array.from(hiddenItems, (element, index) => {
          if (toShow >= (index + 1))
            element.classList.remove('d-none'), element.classList.add('d-block');
        });
        document.querySelectorAll('.border-light.border-1.d-none').length === 0 ? button.target.classList.add('d-none') : false;

        const length = document.querySelectorAll('.border-light.border-1.d-block').length;
        const visibleitems = document.querySelectorAll('.border-light.border-1.d-block');

        Array.from(visibleitems, (element, index) => {
          if (length === (index + 1))
            element.classList.remove('border-bottom');
          else
            element.classList.add('border-bottom');
        });
      };

      onUpdated(() => {
        console.log('updated');
        const items = document.querySelectorAll('.border-light.border-1');
        const button = document.querySelector('.show-more');
        const column = document.querySelector('.publication-filter-list');
        const updatedTitle = document.querySelector('.publication-title');

        Array.from(items, (element, index) => {
          if (toShow < (index + 1))
            element.classList.remove('d-block'), element.classList.add('d-none');
          else
            element.classList.add('d-block');
        });

        if (button != null)
          document.querySelectorAll('.border-bottom.border-light.border-1.d-none').length === 0 ? button.classList.add('d-none') : button.classList.remove('d-none');

        const length = document.querySelectorAll('.border-light.border-1.d-block').length;
        const visibleitems = document.querySelectorAll('.border-light.border-1.d-block');

        //add to every item except the last one and remove from the last one
        visibleitems.forEach((element, index) => {
          if (length !== (index + 1))
            element.classList.add('border-bottom');
          else
            element.classList.remove('border-bottom');
        });

        if (updatedTitle == null && title != null) {
          column.prepend(title);
        }

      });

      return {
        filteredObjects,
        getObjects,
        toShow,
        showMore,
        sortedFilters,
      };
    },
  };
</script>

`
